import axios from 'axios';

const baseURL = process.env.REACT_APP_SIGNBOX_API_URL || 'https://signbox-api.amigoapp.com.br';

const client = axios.create({ baseURL });

const ResponseInterceptor = async response => {
	return Promise.resolve({ data: response.data?.data, status: response.data?.status });
};

const ErrorInterceptor = error => {
	return Promise.resolve({
		error: error.response ? error.response.data : error.message
	});
};

client.interceptors.response.use(ResponseInterceptor, ErrorInterceptor);

export default client;
